import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Button, Container, Link } from '@mui/material';
import { useRouter } from 'next/router';
import { useState } from 'react';

import CustomButton from '../ui/CustomButton';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const ExciseSubMenu = () => {
  const router = useRouter();
  const [selectedSubMenu, setSelectedSubMenu] = useState('');

  function getActiveClassName(currentPath: string[]) {
    const pathName = router.pathname;
    if (pathName === '/' && currentPath.includes('/')) {
      return 'Mui-second-level-selected-menu';
    }
    const matchingPaths = currentPath.filter((p) => pathName.startsWith(p));
    if (matchingPaths.length > 0 && !currentPath.includes('/'))
      return 'Mui-second-level-selected-menu';
    return '';
  }

  // handle click for Sub Menu in Mobile view
  function getSubMenuHoverClassName(currentSubMenu: string) {
    if (
      currentSubMenu !== undefined &&
      currentSubMenu !== '' &&
      selectedSubMenu !== undefined &&
      selectedSubMenu !== '' &&
      selectedSubMenu === currentSubMenu
    ) {
      return 'dropdown-menu button-hover';
    }
    return 'dropdown-menu';
  }

  function toggleSelectedSubMenu(currentSubMenu: string) {
    if (selectedSubMenu !== undefined && selectedSubMenu !== '') {
      if (currentSubMenu !== selectedSubMenu) {
        setSelectedSubMenu(currentSubMenu);
      } else {
        setSelectedSubMenu('');
      }
    } else {
      setSelectedSubMenu(currentSubMenu);
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(235, 235, 235, 0.85)',
        backdropFilter: 'saturate(50%) blur(5px)',
        borderBottom: '1px solid #dcdcdc',
        py: 1,
        px: 3,
        color: '#14181f',
        textAlign: 'right',
        position: 'sticky',
        left: 0,
        right: 0,
        top: 64,
        zIndex: 999,
        minHeight: { sm: 50, md: 54 },
        display: { xs: 'none', sm: 'flex' },
        justifyContent: 'flex-end',
        '& a:hover': { backgroundColor: 'transparent' },
      }}
      component="nav"
      aria-label="Secondary Navigation"
    >
      <Container
        maxWidth="lg"
        sx={{
          p: '0 !important',
          display: 'flex',
          '& .Mui-second-level-selected-menu::before': { bottom: -10 },
        }}
      >
        <CustomButton
          href="/excise-tax/"
          text="Excise Tax<br />Forms"
          custom="margin-right:0px; line-height:1.2; padding-top:0px; padding-bottom:0px; text-align:left;"
          icon={
            <Box
              component="img"
              src="/assets/images/excise-icon.png"
              alt="Excise Tax Forms"
              sx={{ width: { sm: 32, md: 36 }, height: { sm: 32, md: 36 } }}
            />
          }
          // className={getActiveClassName(['/excise-tax'])}
          sm="12px"
          md="14px"
        />
        <Box sx={{ flexGrow: 1 }} />
        <CustomButton
          href="/tools/form-2290-tax-calculator/"
          text="2290 Tax Calculator"
          sm="12px"
          md="14px"
        />

        <Box
          className={getSubMenuHoverClassName('btn-excise-supported-forms')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-excise-supported-forms"
            onClick={() => toggleSelectedSubMenu('btn-excise-supported-forms')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName([
              '/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online',
              '/excise-tax/efile-irs-form-2290-vin-correction-online',
              '/excise-tax/efile-irs-form-8849-schedule-6-online',
              '/excise-tax/free-e-file-form-2290-suspended-vehicles',
              '/excise-tax/efile-irs-form-2290-weight-increased-amendment',
              '/excise-tax/efile-irs-form-2290-mileage-exceeded-amendment',
              '/excise-tax/form-2290-mobile-app',
              '/excise-tax/file-irs-form-2290-by-phone',
              '/excise-tax/click2file-form-2290',
            ])}
          >
            Supported Forms
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{ width: 250, '&:before': { left: 50 } }}
          >
            <Box component="ul">
              {/* <li>
                <Link href="/excise-tax/pre-file-form-2290/">
                  Pre-File Form 2290
                </Link>
              </li> */}
              <li>
                <Link href="/excise-tax/file-irs-form-2290-by-phone/">
                  Phone Filing
                </Link>
              </li>
              <li>
                <Link href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/">
                  Form 2290
                </Link>
              </li>
              <li>
                <Link href="/excise-tax/efile-irs-form-8849-schedule-6-online/">
                  Form 8849
                </Link>
              </li>
              <li>
                <Link href="/excise-tax/free-e-file-form-2290-suspended-vehicles/">
                  Suspended Vehicles
                </Link>
              </li>
              <li>
                <Link href="/excise-tax/efile-irs-form-2290-vin-correction-online/">
                  Form 2290 VIN Correction{' '}
                  <span style={{ fontWeight: 700 }}>(FREE)</span>
                </Link>
              </li>

              <li>
                <Link href="/excise-tax/efile-irs-form-2290-weight-increased-amendment/">
                  Weight Increased Amendment
                </Link>
              </li>
              <li>
                <Link href="/excise-tax/efile-irs-form-2290-mileage-exceeded-amendment/">
                  Mileage Exceeded Amendment
                </Link>
              </li>
              <li>
                <Link href="/excise-tax/click2file-form-2290/">
                  Form 2290 Click2File
                </Link>
              </li>
              <li>
                <Link href="/excise-tax/form-2290-mobile-app/">
                  Form 2290 Mobile App
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-excise-due-dates')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-excise-due-dates"
            onClick={() => toggleSelectedSubMenu('btn-excise-due-dates')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Due Dates
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{ width: 200, '&:before': { left: 50 } }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/excise-tax/form-2290-due-dates/">
                  Form 2290 Due Dates
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-excise-instructions')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-excise-instructions"
            onClick={() => toggleSelectedSubMenu('btn-excise-instructions')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Instructions
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 260,
              left: 'auto !important',
              right: 0,
              '&:before': { right: 50 },
            }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/excise-tax/form-2290-instructions/">
                  Form 2290 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/form-2290-taxable-suspended-vehicles/">
                  Taxables &amp; Suspended Vehicles
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/form-2290-irs-payment-options/">
                  Form 2290 Payment Options
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/form-2290-amendments/">
                  Form 2290 Amendments
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/hvut-form-2290-penalties/">
                  HVUT Form 2290 Penalties
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/form-2290-credit-vehicles/">
                  Form 2290 Credit Vehicles
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/form-2290-filing-guide-for-owner-operators/">
                  Form 2290 Filing Guide
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/automagic2290/">
                  AutoMagic2290
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/form-2290-filing-guide-for-fleet-managers/">
                  Fleet Managers
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/form-2290-schedule-1/">
                  Form 2290 Schedule 1
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/form-2290-taxable-gross-weight-and-weight-categories/">
                  Gross Weight &amp; Categories
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/irp/">
                  International Registration Plan (IRP)
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/filing-form-2290-through-the-mobile-app/">
                  Form 2290 using Mobile App
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/form-8849-schedule-6-instructions/">
                  Form 8849 Schedule 6
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/new-york-hut/">
                  New York HUT
                </Link>
              </li>

              <li>
                <Link href="/resources/excise-tax/kentucky-form-2290/">
                  Kentucky Form 2290
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/kansas-form-2290/">
                  Kansas Form 2290
                </Link>
              </li>
              <li>
                <Link href="/resources/excise-tax/unified-carrier-registration/">
                  Unified Carrier Registration (UCR)
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <CustomButton
          href="/pricing/#excise"
          text="Pricing"
          sm="12px"
          md="14px"
        />
      </Container>
    </Box>
  );
};

export default ExciseSubMenu;
